import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../models";
import { getFirebaseUrl } from "../../state/selectors/selectors";

const SalgSisteMaaned: React.FC = () => {
    const iframeSrc = useSelector((state: RootState) => getFirebaseUrl(state));

    if (!iframeSrc) {
        return (
            <div className="retailer-dashboard-wrapper">
                <p>Kan ikke vise rapporten fordi rapportadressen mangler.</p>
            </div>
        );
    }

    return (
        <div className="retailer-dashboard-wrapper">
            <iframe
                src={iframeSrc}
                style={{ border: "none", width: "100%", maxWidth: "1000px", aspectRatio: "5 / 7" }}
                title="Salg siste måned"
            />
        </div>
    );
};

export default SalgSisteMaaned;
